import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HTTP_CONTEXT, RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { ResponseData } from 'src/app/helper/interface/response';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChurchApiService {
  constructor(
    private http: HttpClient,
    private downloadHelper: downloadHelper
  ) {}
  search(payload) {
    return lastValueFrom(this.http.post(`/church/search`,payload));
  }

  saveDetails(data: any) {
    return lastValueFrom(this.http.post(`/church/save`, data));
  }
  getList(ev: any) {
    return lastValueFrom(this.http.post(`/church/getList/ACTIVE`, ev));
  }
  getListWithProgress(ev: any) {
    return lastValueFrom(this.http.post(`/church/getListWithProgress`, ev));
  }
  getListOnlyDeleted(ev: any) {
    return lastValueFrom(this.http.post(`/church/getList/INACTIVE`,ev));
  }
  getBasic(id: any, isFull = false) {
    return lastValueFrom(this.http.get(`/church/getBasic/${id}/${isFull}`));
  }
  getDetails(id: any) {
    return lastValueFrom(this.http.get(`/church/getDetails/${id}`));
  }
  reliveChurch(id: any, data: any) {
    return lastValueFrom(this.http.post(`/church/relive/${id}`, data));
  }
  updateRequest(id: string | number | Array<any>, data: any) {
    if (Array.isArray(id)) {
      id = id.join(',');
    }
    return lastValueFrom(this.http.post(`/church/updateRequest/${id}`, data));
  }

  saveMember(data: any) {
    return lastValueFrom(this.http.post(`/churchMember/save`, data));
  }
  getMember(id: any) {
    return lastValueFrom(this.http.get(`/churchMember/get/${id}`));
  }
  deleteMember(id: any) {
    return lastValueFrom(this.http.delete(`/churchMember/delete/${id}`, {}));
  }
  reActiveMember(id: any) {
    return lastValueFrom(this.http.post(`/churchMember/reactive/${id}`, {}));
  }

  getMemberList(ev: any, outbox: boolean = false) {
    const api = outbox ? 'INACTIVE' : 'ACTIVE';
    return lastValueFrom(this.http.post(`/churchMember/getList/${api}`, ev));
  }

  getCommitteeMember(id: any) {
    return lastValueFrom(this.http.get(`/church/getCommitteeMember/${id}`));
  }

  searchMember(payload) {
    return lastValueFrom(
      this.http.post(`/churchMember/search`, payload)
    );
  }
  getBelieversTotal(data: any) {
    return lastValueFrom(
      this.http.post(`/churchMember/getBelieversTotal`, data)
    );
  }

  saveReport(data: any) {
    return lastValueFrom(this.http.post(`/churchReport/save`, data));
  }
  getReport(id: any) {
    return lastValueFrom(this.http.get(`/churchReport/get/${id}`));
  }
  deleteReport(data: any) {
    return lastValueFrom(this.http.post(`/churchReport/delete`, data));
  }
  restoreReport(data: any) {
    return lastValueFrom(this.http.post(`/churchReport/restore`, data));
  }
  getReportList(ev: any, outbox: boolean = false) {
    const api = outbox ? 'INACTIVE' : 'ACTIVE';
    return lastValueFrom(this.http.post(`/churchReport/getList/${api}`, ev));
  }
  getTransactionList(ev: any, outbox: boolean = false) {
    const api = outbox ? 'INACTIVE' : 'ACTIVE';
    return lastValueFrom(
      this.http.post(`/churchFinance/getTransactionList/${api}`, ev)
    );
  }
  getIncome(id: any) {
    return lastValueFrom(this.http.get(`/churchFinance/get/${id}`));
  }
  getLedgerBalance(chId: any) {
    return lastValueFrom(
      this.http.get(`/churchFinance/getLedgerBalance/${chId}`)
    );
  }
  async getReportReceipt(data: any, type: 'DOWNLOAD' | 'API' = 'API') {
    const url = '/churchFinance/getReportReceipt';
    return type == 'DOWNLOAD'
      ? await this.downloadHelper.downloadApi(url, 'POST', '', data)
      : lastValueFrom(this.http.post(url, data));
  }

  getIncomeList(ev: any, outbox: boolean = false) {
    const api = outbox ? 'INACTIVE' : 'ACTIVE';
    return lastValueFrom(this.http.post(`/churchFinance/getList/${api}`, ev));
  }
  saveIncome(data: any) {
    return lastValueFrom(this.http.post(`/churchFinance/save`, data));
  }
  deleteIncome(id: any) {
    return lastValueFrom(this.http.delete(`/churchFinance/delete/${id}`));
  }
  restoreIncome(id: any) {
    return lastValueFrom(this.http.post(`/churchFinance/restore/${id}`, {}));
  }
  async getTransaction(data: any, type: 'DOWNLOAD' | 'API' = 'API') {
    const url = '/churchFinance/getTransaction';
    return type == 'DOWNLOAD'
      ? await this.downloadHelper.downloadApi(url, 'POST', '', data)
      : lastValueFrom(this.http.post(url, data));
  }

  getFinChart(data: any) {
    return lastValueFrom(
      this.http.post(`/churchFinance/getLast6MonthsIncomeExpense`, data)
    );
  }

  checkReportExists(date: any) {
    return lastValueFrom(this.http.post(`/churchReport/checkByDate`, date));
  }
  downloadPdfReport(data: any, type: 'EXCEL' | 'PDF' | 'FLAT' = 'PDF') {
    const url = `churchReport/${
      type == 'EXCEL' ? 'getExcelReport' : 'getPdfReport'
    }`;
    return this.downloadHelper.downloadApi(url, 'POST', '', data);
  }

  //progress Report
  saveProgressReport(data: any) {
    return lastValueFrom(this.http.post(`/churchProgress/save`, data));
  }
  approveProgressReport(id, data: any) {
    return lastValueFrom(
      this.http.post(`/churchProgress/approveReport/${id}`, data)
    );
  }
  getProgressReportList(ev: any) {
    return lastValueFrom(this.http.post(`/churchProgress/getList`, ev));
  }
  assignStaff(ev: any) {
    return lastValueFrom(this.http.post(`/church/assignStaff`, ev));
  }

  getProgressDetails(id: any) {
    return lastValueFrom(this.http.get(`/churchProgress/get/${id}`));
  }
  sentMail(id: any, data) {
    return lastValueFrom(
      this.http.post(`/churchProgress/mailSent/${id}`, data)
    );
  }

  checkRequestExists = (data: any): Promise<boolean> => {
    return new Promise((resolve, reject) => {
      console.log(data);
      if (+(data.modify_request || 0) == 1) {
        resolve(false);
        return;
      }
      this.getBasic(data.church_id)
        .then((res: ResponseData | any) => {
          if (res.statusCode == RESPONSE_CODE.SUCCESS) {
            if (res.result) {
              if (+res.result.modify_request == 0) {
                resolve(true);
              }
            }
          }
          resolve(false);
        })
        .catch((err) => {
          reject(true);
        });
    });
  };
}
